export default {
  lawyerStatusApi: {
    getLawyerStatus: 'api/LawyerMonitor/getLawyerStatus'
  }
}